module.exports = __webpack_public_path__ + "static/laboheme9s-b8eb9d66a49293943dffd564645976d7.jpg";